import { apiWrapper } from "@/services/api";

export const validFramesWithCode = async (
  emergency_code,
  multiSheetValidIdsArray
) => {
  try {
    await apiWrapper(
      "POST",
      `emergency_code_frames?code=${emergency_code}`,
      multiSheetValidIdsArray
    );
  } catch (err) {
    console.log("ERROR!! validFramesWithCode()");
    throw err;
  }
};
